import { mapPublicationFilters } from '@pressreader/catalog-common';
import { CatalogMetaDataDto } from '@pressreader/catalog-types';
import { httpGet } from '@pressreader/services';
import { IPagedResult } from '@pressreader/types';

import { DEFAULT_PUBLICATIONS_LOAD_LIMIT } from './constants';
import { IPublicationDto, IPublicationsQuery, IPublicationsQueryRequest } from './types';

function mapPublicationQueryToRequestQuery({
    offset,
    limit = DEFAULT_PUBLICATIONS_LOAD_LIMIT,
    orderBy,
    filters,
}: IPublicationsQuery): IPublicationsQueryRequest {
    const result: IPublicationsQueryRequest = { offset, limit };

    if (orderBy) {
        result.orderBy = orderBy.name ? `${orderBy.name} ${orderBy.order}` : `${orderBy.order}`;
    }

    const filtersRequest = mapPublicationFilters(filters);
    return { ...result, ...filtersRequest };
}

export function findPublications(query: IPublicationsQuery): Promise<IPagedResult<IPublicationDto>> {
    const requestQuery = mapPublicationQueryToRequestQuery(query);
    return httpGet('catalog/v2', 'publications', requestQuery);
}

export function getCatalogMetadata(): Promise<CatalogMetaDataDto> {
    return httpGet('catalog/v2', 'metadata');
}
